import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

export type RespiratoryConfig = {
  Year1: {
    variantId: string;
    alternateVariantId: string;
    price: number;
    discountedPrice: number;
    discountCode: string;
  };
};

export const RespiratoryShopifyMap: Record<ShopifyStore, RespiratoryConfig> = {
  [ShopifyStore.IN]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/44475050459206',
      alternateVariantId: 'gid://shopify/ProductVariant/44475050459206',
      price: 1799,
      discountedPrice: 0,
      discountCode: 'K3AQ925X439E',
    },
  },
  [ShopifyStore.AE]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/62454762111347',
      alternateVariantId: 'gid://shopify/ProductVariant/62454762111347',
      price: 149,
      discountedPrice: 0,
      discountCode: 'AGB2B9QZ9BSB',
    },
  },
  [ShopifyStore.EU]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/57076262961526',
      alternateVariantId: 'gid://shopify/ProductVariant/57076262961526',
      price: 39,
      discountedPrice: 0,
      discountCode: 'BVVGTCHJKEM7',
    },
  },
  [ShopifyStore.GB]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/57076262961526',
      alternateVariantId: 'gid://shopify/ProductVariant/57076262961526',
      price: 39,
      discountedPrice: 0,
      discountCode: 'BVVGTCHJKEM7',
    },
  },
  [ShopifyStore.ROW]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/43845292392508',
      alternateVariantId: 'gid://shopify/ProductVariant/43845292392508',
      price: 39.99,
      discountedPrice: 0,
      discountCode: 'NJHEFK8ETEEW',
    },
  },
  [ShopifyStore.US]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/42481761124448',
      alternateVariantId: 'gid://shopify/ProductVariant/42481761124448',
      price: 39,
      discountedPrice: 0,
      discountCode: 'NDPGABJD1QA2',
    },
  },
  [ShopifyStore.AU]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/57076262961526',
      alternateVariantId: 'gid://shopify/ProductVariant/57076262961526',
      price: 55,
      discountedPrice: 0,
      discountCode: 'BVVGTCHJKEM7',
    },
  },
  [ShopifyStore.CA]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/42481761124448',
      alternateVariantId: 'gid://shopify/ProductVariant/42481761124448',
      price: 50,
      discountedPrice: 0,
      discountCode: 'NDPGABJD1QA2',
    },
  },
  [ShopifyStore.SA]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/57076262961526',
      alternateVariantId: 'gid://shopify/ProductVariant/57076262961526',
      price: 159,
      discountedPrice: 0,
      discountCode: 'BVVGTCHJKEM7',
    },
  },
  [ShopifyStore.MX]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/57076262961526',
      alternateVariantId: 'gid://shopify/ProductVariant/57076262961526',
      price: 700,
      discountedPrice: 0,
      discountCode: 'BVVGTCHJKEM7',
    },
  },
  [ShopifyStore.ZA]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/57076262961526',
      alternateVariantId: 'gid://shopify/ProductVariant/57076262961526',
      price: 659,
      discountedPrice: 0,
      discountCode: 'BVVGTCHJKEM7',
    },
  },
  [ShopifyStore.JP]: {
    Year1: {
      variantId: 'gid://shopify/ProductVariant/57076262961526',
      alternateVariantId: 'gid://shopify/ProductVariant/57076262961526',
      price: 7000,
      discountedPrice: 0,
      discountCode: 'BVVGTCHJKEM7',
    },
  },
};